import { Select as BaseSelect } from "@base-ui/react/select";
import { useFloatingPortalContainer } from "@frontend/contexts";

import type { SelectPortalProps } from "./Select.types";

export function SelectPortal({ children, ...props }: SelectPortalProps) {
  const container = useFloatingPortalContainer();

  return (
    <BaseSelect.Portal
      data-slot="select-portal"
      container={container}
      {...props}
    >
      {children}
    </BaseSelect.Portal>
  );
}
